import { AfterViewInit, Component, ElementRef, Input, Output, EventEmitter, OnInit, NgModule, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { EditRoutingModule } from './edit.routing.module';

declare let $: any;
let afterView: boolean = false;
const errorMessage: any = {
  required: 'Ce champ est requis',
  maxlength: 'Ce champ est trop long ',
  pattern: 'Ce champ doit correspondre au pattern '
};

@Component({
  selector: 'edit',
  template: `
  <div class="md-form form-sm" *ngIf="visible" [ngClass]="{'has-error':error}" [formGroup]="form">
    <i *ngIf="glyph" class="{{glyph}} prefix" [ngClass]="{'active':control.value != null}" style="top: -0.3rem;"></i>
    <input type="text" id="{{name}}" (focus)="onFocus()" [ngStyle]="{'font-style': (readonly ? 'italic' :'') }" class="form-control editcomp  mb-0"
      [formControl]="control" [attr.length]="length" [ngClass]="{'invalid': error}" [readonly]="readonly" #edit>
    <label for="{{name}}" [ngStyle]="{'top': (!control.value ? '.5rem' :'')}" style="text-align:left; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;"
      [ngClass]="{'active':control.value != null}">
      <em *ngIf="readonly">{{caption}}</em>
      <b *ngIf="!readonly">{{caption}}</b>
      <span *ngIf="required && (control.value == null)" style="color: red;">
        <b>*</b>
      </span>
    </label>
    <span *ngIf="error" class="help-block text-danger" [ngStyle]="{'padding-left': (glyph ? '34px' :'')}" style="font-size: 15px">
      <b>{{ error }}</b>
    </span>
  </div>`,
  styles: [`
  .editcomp {
      margin-bottom: 1.5rem;
      margin-top: 1rem;
  }
  .editcomp.ng-invalid {
      border-bottom: 1px solid #F44336;
      box-shadow: 0 1px 0 0 #F44336;
  }
  input[type=text]:focus:not([readonly]) {
      border-color: #007bff !important;
      box-shadow: 0 1px 0 0 #007bff !important;
  }

  input:-webkit-autofill {
      background-color: none;
  }`],
  encapsulation: ViewEncapsulation.None,
})

export class EditComponent implements OnInit {
  @Input() public name: string = '';
  @Input() public length: string = '0';
  @Input() public caption: string = '';
  @Input() public readonly: boolean = false;
  @Input() public control: AbstractControl;
  @Input() public enabled: boolean = false;
  @Input() public value: string = '';
  @Input() public glyph: string = '';
  @Output() public valueChange = new EventEmitter<string>();
  @Input() public form: FormGroup;
  @Input() public error: any;
  @Input() public required: boolean = false;
  @Input() public displayCharacterCounter: boolean = true;
  @ViewChild('edit') edit: ElementRef;
  public elementRef: ElementRef;
  @Input() public visible: boolean = true;
  @Input() public validators: ValidatorFn[] = new Array<ValidatorFn>();
  @Input() public pattern: any = null;
  @Input() public patternHint: string = '';
  @Input() public upperCase: boolean = true;
  @Input() public init: boolean = false;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit(): void {
    if (!this.control) {
      if (this.form.controls[this.name] == null) {
        this.control = new FormControl();
        this.form.addControl(this.name, this.control);
      }
      this.control = this.form.controls[this.name];
    }
    this.updateValidators();
    this.control.valueChanges
      /*.map((value) => {
        if (value && this.upperCase) {
          value = value.toUpperCase();
        }
        return value;
      })*/
      .subscribe((value) => {
        this.returnError();
      });
    this.init = true;
  }

  ngOnChanges(change: any) {
    if (this.init) {
      if (change.required || change.pattern ||  change.length) {
        this.updateValidators();
      }
    }
  }

  updateValidators() {
    this.validators = new Array<ValidatorFn>();
    if (this.required) {
      this.validators.push(Validators.required);
    }
    if (this.length != '0') {
      this.validators.push(Validators.maxLength(parseInt(this.length)));
    }
    if (this.pattern) {
      this.validators.push(Validators.pattern(this.pattern));
    }
    this.control.setValidators(this.validators);
    this.control.updateValueAndValidity();
  }

  addErrorMessage(key: string, msg: string) {
    errorMessage[key] = msg;
  }

  onFocus() {
    if (this.readonly) {
      $(this.edit.nativeElement).blur();
    }
  }

  setValue(value: string) {
    this.control.patchValue(value);
  }

  ngAfterViewInit() {
    if (!afterView && (this.length != '0') && (this.displayCharacterCounter)) {
      afterView = true;
      $(this.edit.nativeElement).characterCounter();
    }
  }

  setReadonly(readonly: boolean) {
    this.readonly = readonly;
  }

  setPattern(pattern: string) {
    this.pattern = pattern;
    this.updateValidators();
  }

  returnError() {
    this.error = '';
    if (this.control && !this.control.valid && this.control.errors) {
      for (const key in this.control.errors) {
        if (key in errorMessage) {
          if (key == 'pattern') {
            this.error += errorMessage[key] + ' ' + this.patternHint + ' ';
          } else if (key == 'maxlength') {
            this.error += errorMessage[key] + ' ' + this.length + ' ';
          } else {
            this.error += errorMessage[key] + ' ';
          }
        }
      }
    }
  }
}
